/* eslint-disable no-sequences */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-undef */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const dataLayerConsentTracking = require('plugin-seo/components/consentTracking');
const utils = require('../utils');
/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */

function hideConsentBar(consentBar) {
    if (consentBar.hasClass('overlay-on')) {
        consentBar.modal('hide');
    } else {
        consentBar.hide();
    }
}

function showCookiesPolicyModal() {
    const modalInfoCookiesTrigger = $('.consent-info > .content-asset > .tracking-consent a');

    if (modalInfoCookiesTrigger.length) {
        $('body').on('click', '.consent-info > .content-asset > .tracking-consent a', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const cookiesPolicyContent = $('.policy-info-cookies');
            const cookiesModalInfo = $('.cookiesModalInfo');

            if (cookiesPolicyContent.length && !cookiesPolicyContent.hasClass('show')) {
                const cookiesPolicyContentClone = $('.policy-info-cookies').clone();
                $('.policy-info-cookies').remove();
                cookiesPolicyContentClone.modal();
                cookiesPolicyContentClone.addClass('cookiesModalInfo');
                cookiesPolicyContentClone.removeClass('d-none');
            }

            if (cookiesModalInfo.length && !cookiesModalInfo.hasClass('show')) {
                $('.cookiesModalInfo').modal('show');
            }
        });

        modalInfoCookiesTrigger.on('click', '.icon-cross-line', () => {
            hideConsentBar('.policy-info-cookies');
        });
    }
}

function executeConsentTrackingEvents(consentBar) {
    // click on button of modal (affirm or decline) and set vars
    consentBar.on('click', '.button-wrapper button.affirm', (e) => {
        const thisTarget = $(e.currentTarget);
        const trackingConsent = $('.tracking-consent.api-true');
        const url = thisTarget.data('url');
        const token = trackingConsent.data('token');
        let formData = {};

        if (consentBar
            .find('#cookie-analisys').length > 0) {
            formData = {
                personalization:
                            thisTarget.hasClass('affirm') === true
                                ? consentBar
                                    .find('#cookie-personalization')
                                    .is(':checked')
                                    .toString()
                                : 'false',
                marketing:
                            thisTarget.hasClass('affirm') === true
                                ? consentBar
                                    .find('#cookie-analisys')
                                    .is(':checked')
                                    .toString()
                                : 'false',
                consent: 'true',
                csrf_token: token,
            };
        } else {
            formData = {
                personalization: 'true',
                marketing: 'true',
                consent: 'true',
                csrf_token: token,
            };
        }

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success(data) {
                hideConsentBar(consentBar);

                dataLayerConsentTracking.consentCTABarResponse(data);
            },
            error(err) {
                hideConsentBar(consentBar);

                // Expected error response is for CSRF failure,
                // which will include a redirect to CSRF-Fail
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    });

    // click on button of modal (affirm or decline) and set vars
    consentBar.on('click', '.button-wrapper button.decline', (e) => {
        const thisTarget = $(e.currentTarget);
        const trackingConsent = $('.tracking-consent.api-true');
        const url = thisTarget.data('url');
        const token = trackingConsent.data('token');
        let formData = {};


        formData = {
            personalization: 'false',
            marketing: 'false',
            consent: 'true',
            csrf_token: token,
        };

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success(data) {
                hideConsentBar(consentBar);

                dataLayerConsentTracking.consentCTABarResponse(data);
            },
            error(err) {
                hideConsentBar(consentBar);

                // Expected error response is for CSRF failure,
                // which will include a redirect to CSRF-Fail
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    });

    consentBar.on('click', '.showCookies', (e) => {
        const consentMoreInfo = consentBar.find('.consent_more_info');
        const inputsToHide = ['.personalization', '.analisys'];

        $(e.currentTarget).hide();
        consentBar.find('.cookie-all').removeClass('d-none');
        consentMoreInfo.show();
        consentBar.find('.affirm').text(consentBar.find('.affirm').data('replace'));

        inputsToHide.forEach((elem) => {
            const consentInput = consentMoreInfo.find(`${elem} input`);

            if (consentInput.length) {
                consentInput[0].checked = false;
            }
        });
    });

    consentBar.on('click', '.cookie-all', (e) => {
        const thisTarget = $(e.currentTarget);
        if (thisTarget.hasClass('active')) {
            $('.custom-control-input').prop('checked', true);
            thisTarget.removeClass('active');
            thisTarget.text(thisTarget.attr('data-replace-basic'));
        } else {
            $('.custom-control-input').not('#cookie-techniques').prop('checked', false);
            thisTarget.addClass('active');
            thisTarget.text(thisTarget.attr('data-replace-all'));
        }
    });
}

function showConsentCTABar() {
    const tracking = $('.tracking-consent');
    const consentBar = $('#consent-tracking');
    const dataType = tracking.data('type');

    if (!tracking.data('caonline')) {
        return;
    }

    // check type of showcookies
    if (dataType) {
        if (consentBar.hasClass('overlay-on')) {
            consentBar.modal('show');
        } else {
            consentBar.show();
        }
    }
}

module.exports = () => {
    const cookieShow = utils.getCookie('showConsentTracking');
    const isCached = document.getElementsByTagName('base').length > 0;
    const tracking = $('.tracking-consent');
    const consentBar = $('#consent-tracking');

    if (($('.consented').length === 0 && tracking.hasClass('api-true')) && !isCached && cookieShow === '') {
        showConsentCTABar();
    }

    if (isCached) {
        $(document.body).addClass('google-cached-page');
    }

    if (consentBar.length) {
        $('body').on('click', '.consent-tracking-trigger', () => {
            if (consentBar.hasClass('overlay-on')) {
                consentBar.modal('show');
            } else {
                consentBar.show();
            }
        });

        executeConsentTrackingEvents(consentBar);
    }

    if (tracking.hasClass('api-true')) {
        tracking.click(() => {
            showConsentCTABar();
        });
    }

    showCookiesPolicyModal();
};
